import { ObjectKeyToLine } from '@/utils';
import type { CaptchaType } from '@/service/user';
import { getInitCaptcha } from '@/service/user';
import { track } from '@/utils/track';

export const assetsPath = 'https://static.textin.com/deps/geetest.js';

// 重新初始化geetest.js
const reloadHandle = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = assetsPath;
    // 超时时间
    const timeout = setTimeout(() => {
      reject('加载geetest.js超时');
    }, 1000 * 5);
    script.onload = () => {
      clearTimeout(timeout);
      resolve(true);
    };
    script.onerror = (err) => {
      clearTimeout(timeout);
      reject(err);
    };
    document.body.append(script);
  });
};

export const initGeetestCaptcha = async (sence?: CaptchaType): Promise<any> => {
  let response: any;
  let message;
  try {
    const response1 = await getInitCaptcha(sence);
    if (response1.code === 200) {
      response = response1;
    } else {
      message = response1;
    }
  } catch (error: any) {
    console.log('init_captcha error', error);
    message = { msg: error?.message, url: error?.request?.originUrl, res: error?.response };
  }

  if (!response) {
    track({ name: '极验错误', keyword: 'init_captcha第一次失败', message });
    // 如果失败，重试一次
    response = await getInitCaptcha(sence);
  }

  const { data, code, msg } = response;
  if (code !== 200) {
    track({ name: '极验错误', keyword: 'init_captcha结果非200', message: response });
    return Promise.reject({ code, msg });
  }

  const { new_captcha, success, gt, challenge } = ObjectKeyToLine(data);

  return new Promise(async (resolve, reject) => {
    if (!window.initGeetest) {
      track({ name: '极验错误', keyword: 'initGeetest不存在，重试' });
      // initGeetest不存在，重新加载
      try {
        await reloadHandle();
      } catch (error) {
        track({ name: '极验错误', keyword: 'cdn重新初始化失败', message: error });
        reject({ msg: '网络或资源加载失败，请刷新重试' });
        return;
      }
    }
    if (window.initGeetest) {
      window.initGeetest(
        {
          gt,
          challenge,
          offline: !success,
          new_captcha,
          product: 'bind', // 隐藏按钮式
        },
        (result: any) => {
          resolve({ challenge, captchaObj: result });
        },
      );
    } else {
      track({ name: '极验错误', keyword: 'initGeetest不存在' });
      reject({ msg: '网络或资源加载失败，请刷新重试' });
    }
  });
};
